// Admin API client — /admin/short-links/* (mirrors the API's short-links aggregate, A7Y-5290).

import type {
  AdminShortLink,
  AdminShortLinkListResponse,
  AdminShortLinkStatsResponse,
  ShortLinkCreateRequest,
} from '@a7y/types';
import { client } from './transport';

export const shortLinksApi = {
  getShortLinks: () => client.get<AdminShortLinkListResponse>('/short-links'),
  createShortLink: (data: ShortLinkCreateRequest) =>
    client.post<{ link: AdminShortLink }>('/short-links', data),
  getShortLinkStats: (force = false) =>
    client.get<AdminShortLinkStatsResponse>(`/short-links/stats${force ? '?force=1' : ''}`),
};
